// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1AnZz","bigColWidth":"Table_bigColWidth__1Qrrr","biggerColWidth":"Table_biggerColWidth__3maIF","row":"Table_row__V3MiI","col":"Table_col__2jcJy"};